/** Header per far costruire al backend link email con l'URL del sito corrente. */
export function withFrontendOrigin(
	headers: Record<string, string> = {}
): Record<string, string> {
	if (typeof window === "undefined") return headers;
	return {
		...headers,
		"X-Frontend-Origin": window.location.origin,
	};
}
